import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './ResetPassword.css';
import { sendPasswordReset } from '../../auth';

function ResetPasswordPage() {
    const navigate = useNavigate();
    const [email, setEmail] = useState('');
    const [error, setError] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const [emailSent, setEmailSent] = useState(false);

    const handleInputChange = (e) => {
        setEmail(e.target.value);
        if (error) {
            setError('');
        }
    };

    const validateEmail = () => {
        if (!email) {
            setError('Email is required');
            return false;
        }
        if (!/\S+@\S+\.\S+/.test(email)) {
            setError('Email is invalid');
            return false;
        }
        return true;
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!validateEmail()) {
            return;
        }

        setIsLoading(true);
        try {
            await sendPasswordReset(email);
            setEmailSent(true);
        } catch (error) {
            console.error('Reset password error:', error.message);
            setError(error.message || 'Failed to send reset email. Please try again.');
        } finally {
            setIsLoading(false);
        }
    };

    const handleBackToLogin = () => {
        navigate('/login');
    };

    if (emailSent) {
        return (
            <div className="reset-password-container">
                <div className="reset-password-body">
                    <div className="reset-password-image-section">

                        <img src="/images/UCI_Donald_Bren_Hall.jpg" alt="Donald Bren Hall" />
                    </div>
                    <div className="reset-password-form-section">
                        <div className="reset-password-content">
                            <div className="success-icon">✓</div>
                            <h1 className="reset-password-title">Check Your Email</h1>
                            <p className="reset-password-message">
                                We've sent a password reset link to <strong>{email}</strong>
                            </p>
                            <p className="reset-password-instructions">
                                Please check your email and click the link to reset your password. The link will expire in 1 hour.
                            </p>
                            <div className="reset-password-tips">
                                <p className="tips-title">
                                    Didn't receive the email?
                                </p>
                                <ul>
                                    <li>Check your spam folder</li>
                                    <li>Make sure you entered the correct email</li>
                                </ul>
                            </div>
                            <button onClick={handleBackToLogin} className="back-to-login-button">
                                Back to Login
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    return (
        <div className="reset-password-container">
            <div className="reset-password-body">
                <div className="reset-password-image-section">
                    <img src="/images/UCI_Donald_Bren_Hall.jpg" alt="Donald Bren Hall" />
                </div>
                <div className="reset-password-form-section">
                    <div className="reset-password-content">
                        <h1 className="reset-password-title">Reset Your Password</h1>
                        <p className="reset-password-subtitle">
                            Enter your email and we'll send you a link to reset your password.
                        </p>
                        
                        <form onSubmit={handleSubmit} className="reset-password-form">
                            <div className="form-group">
                                <label htmlFor="email">Email</label>
                                <input
                                    type="email" id="email" name="email" value={email}
                                    onChange={handleInputChange} className={`form-input ${error ? 'error' : ''}`}
                                    placeholder="" autoFocus
                                />
                                {error && <span className="error-message">{error}</span>}
                            </div>

                            <button 
                                type="submit" className="reset-password-button" disabled={isLoading}
                            >
                                {isLoading ? 'Sending...' : 'Send Reset Link'}
                            </button>
                        </form>

                        <div className="back-to-login-section">
                            <button onClick={handleBackToLogin} className="back-link">
                                Back to Login
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default ResetPasswordPage;
